window.arjoSubscriptionPopupModule =
  window.arjoSubscriptionPopupModule ||
  (() => {
    const state = {
      isInitialized: false,
      elements: {},
    };

    const getElement = (id) => state.elements[id];

    const classNamePrefix = 'arjo-o-subscription-popup';
    const triggerAttr = 'data-subscription-popup-id';
    const forPopupCloseAttr = 'close-popup';

    const setUp = () => {
      const els = [...document.querySelectorAll(`.${classNamePrefix}`)];
      els.forEach((el) => {
        const id = el.dataset.popupId;
        if (!id) return;

        const successMessage = el.dataset['message-200'];
        const alreadySubscribedMessage = el.dataset['message-201'];
        const failedMessage = el.dataset['message-4xx-5xx'];

        const url = el.dataset.subscriptionUrl;
        const callSubscriptionApi = ({subscribeProductNews, subscribePressReleasesAndRegulatoryNews, subscriberEmail, subscribeNews}) => {
          return axios.request({
            method: 'post',
            url: url,
            data: {subscribeProductNews, subscribePressReleasesAndRegulatoryNews, subscriberEmail, subscribeNews},
            headers: {
              Accept: '*/*',
            },
          });
        };

        const innerState = {
          submitted: false,
        };

        const closeButton = el.querySelector(`.${classNamePrefix}__close-button`);
        const resultOkButton = el.querySelector(`.${classNamePrefix}__result button`);
        const submitButton = el.querySelector(`.${classNamePrefix}__submit-container button`);
        const form = el.querySelector(`.${classNamePrefix} form`);

        const checkContainer = el.querySelector(`.${classNamePrefix}__area-of-interest-container`);
        const inputContainer = el.querySelector(`.${classNamePrefix}__email-input-container`);

        const productNewsCheck = el.querySelector(`.${classNamePrefix} form [name='productNews']`);
        const pressReleaseAndRegulatoryNewsCheck = el.querySelector(`.${classNamePrefix} form [name='pressReleaseAndRegulatoryNews']`);
        const newsCheck = el.querySelector(`.${classNamePrefix} form [name='news']`);
        const emailInput = el.querySelector(`.${classNamePrefix} form [name='email']`);
        const policyInput = el.querySelector(`.${classNamePrefix} input[name=acceptPolicy]`);

        const resultDom = el.querySelector(`.${classNamePrefix}__message`);

        const setMessage = (message) => {
          resultDom.innerText = message;
        };

        const setSubmitButtonState = (state) => {
          if (state) {
            submitButton.removeAttribute('disabled');
          } else {
            submitButton.setAttribute('disabled', true);
          }
        };

        setSubmitButtonState(policyInput ? policyInput.checked : true);

        const validateForm = () => {
          const result = {
            areaOfInterestIsValid: true,
            emailIsValid: true,
          };

          if (!(productNewsCheck?.checked || pressReleaseAndRegulatoryNewsCheck?.checked || newsCheck?.checked)) result.areaOfInterestIsValid = false;

          const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);
          if (emailInput.value.length === 0 || !emailRegex.test(emailInput.value)) result.emailIsValid = false;

          return result;
        };

        const toggleErrorMessage = ({areaOfInterestIsValid, emailIsValid}) => {
          if (areaOfInterestIsValid) {
            checkContainer.classList.remove('has-error');
          } else {
            checkContainer.classList.add('has-error');
          }

          if (emailIsValid) {
            inputContainer.classList.remove('has-error');
          } else {
            inputContainer.classList.add('has-error');
          }
        };

        const showLoading = (isLoading) => {
          if (isLoading) {
            el.classList.add('is-loading');
          } else {
            el.classList.remove('is-loading');
          }
        };

        const resetForm = () => {
          toggleErrorMessage({areaOfInterestIsValid: true, emailIsValid: true});
          productNewsCheck.checked = false;
          pressReleaseAndRegulatoryNewsCheck.checked = false;
          emailInput.value = null;
          innerState.submitted = false;
        };

        const resetPopup = () => {
          showLoading(false);
          showResult(false);
          resetForm();
          resultOkButton.removeAttribute(forPopupCloseAttr);
        };

        const showPopup = (isActive) => {
          if (isActive) {
            el.classList.add('is-active');
          } else {
            el.classList.remove('is-active');
            resetPopup();
          }
        };

        const showResult = (isDisplayingResult) => {
          if (isDisplayingResult) {
            el.classList.add('is-displaying-result');
          } else {
            el.classList.remove('is-displaying-result');
            setMessage('');
          }
        };

        closeButton.addEventListener('click', () => {
          showPopup(false);
        });

        resultOkButton.addEventListener('click', (e) => {
          if (e.target.hasAttribute(forPopupCloseAttr)) {
            showPopup(false);
          } else {
            showResult(false);
          }
        });

        const submitHandler = () => {
          showLoading(true);

          callSubscriptionApi({
            subscribeProductNews: productNewsCheck.checked,
            subscribePressReleasesAndRegulatoryNews: pressReleaseAndRegulatoryNewsCheck.checked,
            subscriberEmail: emailInput.value,
            subscribeNews: newsCheck.checked,
          })
            .then((res) => {
              const {status} = res;
              switch (status) {
                case 200:
                  setMessage(successMessage);
                  resultOkButton.setAttribute(forPopupCloseAttr, '');
                  showResult(true);
                  break;
                case 201:
                  setMessage(alreadySubscribedMessage);
                  showResult(true);
                  break;
                default:
                  break;
              }
            })
            .catch(() => {
              setMessage(failedMessage);
              showResult(true);
            })
            .finally(() => {
              resetForm();
              showLoading(false);
            });
        };

        submitButton.addEventListener('click', () => {
          if (!innerState.submitted) innerState.submitted = true;
          const {areaOfInterestIsValid, emailIsValid} = validateForm();
          toggleErrorMessage({areaOfInterestIsValid, emailIsValid});
          if (areaOfInterestIsValid && emailIsValid) {
            submitHandler();
          }
        });

        form.addEventListener('submit', (e) => {
          e.preventDefault();
          if (!innerState.submitted) innerState.submitted = true;

          const {areaOfInterestIsValid, emailIsValid} = validateForm();

          toggleErrorMessage({areaOfInterestIsValid, emailIsValid});

          if (areaOfInterestIsValid && emailIsValid) {
            submitHandler();
          }
        });

        inputContainer.addEventListener('input', () => {
          if (!innerState.submitted) return;
          const {areaOfInterestIsValid, emailIsValid} = validateForm();
          toggleErrorMessage({areaOfInterestIsValid, emailIsValid});
        });

        checkContainer.addEventListener('change', () => {
          if (!innerState.submitted) return;
          const {areaOfInterestIsValid, emailIsValid} = validateForm();
          toggleErrorMessage({areaOfInterestIsValid, emailIsValid});
        });

        policyInput &&
        policyInput.addEventListener('change', (e) => {
          setSubmitButtonState(e.target?.checked);
        });

        state.elements[id] = (() => {
          return {showPopup};
        })();
      });
    };

    const setUpForTrigger = () => {
      const els = [...document.querySelectorAll(`[${triggerAttr}]`)];
      const clickHandler = (e) => {
        const popupId = e.target.dataset.subscriptionPopupId;
        if (!!popupId && !!getElement(popupId)) {
          getElement(popupId).showPopup(true);
        }
      };
      els.forEach((el) => {
        el.addEventListener('click', clickHandler);
      });
    };

    const init = () => {
      if (state.isInitialized) return;
      setUp();
      setUpForTrigger();
      state.isInitialized = true;
    };

    return {init};
  })();

window.addEventListener('load', window.arjoSubscriptionPopupModule.init);
